const AppConfig = {
  appName: "Roots"
};

export default AppConfig;
